<template>
  <div v-show="showPagination" id="pagination" class="flex justify-center md:justify-end mt-0 mb-8 md:mr-18">
    <nav aria-label="Page navigation">
      <ul class="flex items-center space-x-4 flex-wrap">
        <li class="page-item">
          <button type="button" class="
                            flex items-center justify-center
                            w-10 h-10 border-2 rounded-lg
                            hover:bg-transparent
                            text-gray-mobly54
                            hover:border-orange-mobly
                            focus:outline-none
                            transition duration-150 ease-in-out " :disabled="pagination.page === 1"
            @click="$emit('prev-page')" aria-label="Previous">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
            </svg>
          </button>
        </li>
        <li class="page-item" v-for="item in displayedPages" :key="item">
          <button v-if="item !== '...'" type="button" :class="[
            item === pagination.page
              ? 'text-purple-mobly font-bold'
              : 'text-gray-500 hover:text-purple-mobly'
          ]" class="
                            flex items-center justify-center
                            w-10 h-10 font-semibold 
                            bg-transparent 
                            focus:outline-none focus:ring-2 
                            focus:ring-orange-mobly 
                            focus:ring-opacity-50
                            transition duration-150 ease-in-out
                          " @click="$emit('go-to-page', item)">
            {{ item }}
          </button>
          <span v-else class="
              flex items-center justify-center
              w-10 h-10 font-semibold 
              bg-transparent 
              text-gray-500
              cursor-default
            ">
            ...
          </span>
        </li>
        <li class="page-item">
          <button type="button" class="
                            flex items-center justify-center
                            w-10 h-10 border-2 rounded-lg
                            hover:bg-transparent
                            text-gray-mobly54
                            hover:border-orange-mobly
                            focus:outline-none
                            transition duration-150 ease-in-out
                            " :disabled="pagination.page === totalPageCount" @click="$emit('next-page')"
            aria-label="Next">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import namespace from '../../vuex/namespace'
import { mapState } from 'vuex'

export default {
  name: 'Pagination',
  props: {
    showPagination: {
      type: Boolean,
      default: false
    },
    mobileBreakpoint: {
    type: Number,
    default: 768
  }
  },
  data() {
    return {
      windowWidth: window.innerWidth
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    ...mapState(namespace.ORDERS, [
      'pagination'
    ]),
    totalPageCount() {
      return this.pagination.quantityPage ||
        (this.pagination.listPage && this.pagination.listPage.length
          ? this.pagination.listPage[this.pagination.listPage.length - 1]
          : 0);
    },
    displayedPages() {
      const totalPages = this.totalPageCount;
      const currentPage = this.pagination.page;
      const isMobile = this.windowWidth <= this.mobileBreakpoint;
      const pagesToShow = isMobile ? 3 : 5;
      
      const pages = [];

      if (totalPages <= pagesToShow + (isMobile ? 0 : 2)) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
      }

      if (currentPage <= pagesToShow - 1) {
        for (let i = 1; i <= pagesToShow; i++) {
          pages.push(i);
        }
        if (isMobile) {
            pages.push('...');
        } else {
            pages.push('...');
            pages.push(totalPages);
        }
        return pages;
      }

      if (currentPage >= totalPages - (pagesToShow - 2)) {
        if (!isMobile) {
            pages.push(1);
            pages.push('...');
        }
        for (let i = totalPages - (pagesToShow - 1); i <= totalPages; i++) {
          pages.push(i);
        }
        return pages;
      }

      const sidePages = isMobile ? 1 : Math.floor(pagesToShow / 2)
      if (!isMobile) {
          pages.push(1)
          pages.push('...')
      } else {
          pages.push('...')
      }

      for (let i = currentPage - sidePages; i <= currentPage + sidePages; i++) {
        pages.push(i);
      }
      pages.push('...');
      if (!isMobile) {
          pages.push(totalPages);
      }
      return pages;
    }
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    scroll() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped lang="scss">
#pagination {
  margin: 50px 0 20px;

  ul {
    li {
      margin: 0 4px;

      .btn {
        line-height: 18px;
      }

      .btn.btn-wrap-pagination,
      .btn.btn-outline-pagination {
        width: 40px;
        padding-left: 5px;
        padding-right: 5px;
      }

      .btn.btn-wrap-arrow {
        line-height: 14px;
      }
    }

    li.arrow.previous {
      padding-right: 15px;
    }

    li.arrow.next {
      padding-left: 15px;
    }
  }
}
</style>
